import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import "./style.css";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { ReactComponent as ClockLogo } from "../../../assets/images/ChatImages/time.svg";
import { ReactComponent as Location } from "../../../assets/images/ChatImages/location.svg";
import { ReactComponent as Tag } from "../../../assets/images/ChatImages/tag.svg";
import { ReactComponent as TagEmail } from "../../../assets/images/ChatImages/tagemail.svg";
import { ReactComponent as Download } from "../../../assets/images/ChatImages/download.svg";
import { ReactComponent as Add } from "../../../assets/images/ChatImages/add.svg";
import { ReactComponent as PendingUser } from "../../../assets/images/ChatImages/profilechat.svg";
import { ReactComponent as DotsMenu } from "../../../assets/images/ChatImages/dotsmenu.svg";
import { ReactComponent as Ban } from "../../../assets/images/ChatImages/ban.svg";
import { ReactComponent as CloseChat } from "../../../assets/images/ChatImages/stopchat.svg";
import TagMenu from "./TagMenu";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../api/ApiConfig";
import { createAppSocket } from '../../../api/createAppSocket';
import { useSocket } from "../../../SocketContext";
import { LIVE_CHAT_HOME_PATH } from "../../../config/featureFlags";
import { msgTime } from "../../../utils/index";

const ENDPOINT = `${BASE_URL}`;

function ChatHeader(props) {
  const {
    latestMsgTime,
    selectUser,
    setTicketPopup,
    setTranscriptPopup,
    setAssignChatPopup,
    archivedRoom,
    customerData,
  } = props;
  const [chatMenu, setChatMenu] = useState(false);
  const [tagMenu, setTagMenu] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const userData = useSelector((state) => state.loginToken);

  const socketRef = useRef();

  console.log(selectUser, 'selectUser in ChatHeader')

  useEffect(() => {
    socketRef.current = createAppSocket();

    return () => {
      // socketRef.current.disconnect();
    };
  }, []);

  const handleArchive = () => {

    const payload = {
      business_id: selectUser.businessId,
      userId: selectUser.customerId || null,
    }
    // Emit socket event
    socketRef.current.emit("archive-chat", selectUser.id);
    socketRef.current.emit("mark-read", selectUser.id);
     socketRef.current.emit("visitor_tab_closed", payload);

    navigate(LIVE_CHAT_HOME_PATH)
    archivedRoom();
  };

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setChatMenu(false);
        setTagMenu(false);
      }
    };

    if (chatMenu || tagMenu) {
      window.addEventListener("click", handleOutsideClick);
    }

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [chatMenu, tagMenu]);


  const formatTime = (time) =>
    `${new Date().toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })} ${time}`;

  const handleMenuClick = () => {
    setChatMenu(true);
  };

  const safeSelectUserTime = typeof selectUser?.time === "string" ? selectUser.time : "";
  const displayedTime = latestMsgTime == null
    ? (safeSelectUserTime.length === 8 ? formatTime(safeSelectUserTime) : safeSelectUserTime)
    : latestMsgTime;

  return (
    <div className="ChatHeader-Main-Container" style={{
      width: '100%',
      margin: 0,
      padding: 0,
      boxSizing: 'border-box'
    }}>
      <div className="ChatHeader-Container">
        <p className="ChatHeader-Text" style={{ textTransform: 'capitalize' }}>
          {selectUser ? selectUser.title : "No Select User"}
        </p>
        <div style={{

          flex: 1,
          justifyContent: 'space-between', // Fixed: was justifyItems
          display: 'flex',
          width: '100%',
          marginTop: '10px',
          alignItems: 'center' // Optional: for vertical alignment
        }}>

          <div className="ChatHeader-ClockContainer">
            <p>
              <ClockLogo />
            </p>
            <p className="ChatHeaderTxt">
              {selectUser
                ? displayedTime
                : " "}
            </p>
            <p className="line" />
            <p>
              <Location />
            </p>
            <p className="ChatHeaderTxt">
              {selectUser ? customerData[0]?.location : " "}
            </p>
          </div>
          <div ref={dropdownRef} style={{ position: "relative" }}>
            <div className="ChatHeader-Logo-Container">
              {/* <BootstrapTooltip title="Tags" placement="top"> */}
              {/* <p onClick={() => setTagMenu(true)}>
              <Tag />
              {tagMenu && <TagMenu />}
            </p> */}
              {/* </BootstrapTooltip> */}
              <BootstrapTooltip title="Send Transcript" placement="top">
                <p onClick={() => setTranscriptPopup(true)}>
                  <TagEmail />
                </p>
              </BootstrapTooltip>
              <BootstrapTooltip title="Download Transcript" placement="top">
                <p>
                  <Download />
                </p>
              </BootstrapTooltip>
              <BootstrapTooltip title="Create Ticket" placement="top">
                <p onClick={() => setTicketPopup(true)}>
                  <Add />
                </p>
              </BootstrapTooltip>

              {selectUser?.id && (
                <BootstrapTooltip title="Assign Chat" placement="top">
                  <p onClick={() => setAssignChatPopup(true)}>
                    <PendingUser />
                  </p>
                </BootstrapTooltip>
              )}
              <p onClick={handleMenuClick}>
                <DotsMenu />
              </p>
            </div>
            {chatMenu && selectUser?.id && (
              <div className="dropdown-chat-menu">
                <ul>
                  <li>
                    <p>
                      <Ban />
                    </p>
                    Ban this visitor
                  </li>
                  {!selectUser?.is_archived && (
                    <li className="stop-chat-text" onClick={handleArchive}>
                      <p>
                        <CloseChat />
                      </p>
                      End Chat
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>


      </div>
    </div>
  );
}

export default ChatHeader;
